import React from 'react';
import { FieldAssetColumnProps } from 'jsx/@types';
import {
  Flex,
  OperationalStatusIcon,
  prmStatusHelper,
} from '@mss/mss-component-library';
import { Activity } from 'react-feather';
import { Col, Row, Tooltip } from 'antd';

const columns = ({ t, assetManagementApps }: FieldAssetColumnProps) => [
  {
    title: <Activity size={18} className="mr-2 ml-2" />,
    dataIndex: ['asset_data', 'status_icon'],
    key: 'asset_state',
    width: 45,
    render: (value: any, row:any) => (
      <Tooltip
        style={{ lineHeight: 1 }}
        title={
          <div>
            <Row>
              <Col className="mr-1">
                <small>
                  <b>{t('Status')}</b>:
                </small>
              </Col>
              <Col>
                <small>{prmStatusHelper(value, t)}</small>
              </Col>
            </Row>
          </div>
        }
        placement="right"
      >
        <Flex h="center" v="center" className="ml-1 text-gray-500">
          <OperationalStatusIcon
            operationalStatus={row.operational_status}
            heartbeatStatus={value}
          />
        </Flex>
      </Tooltip>
    ),
  },
  {
    title: t('Name'),
    dataIndex: ['name'],
    key: 'name',
    sorter: () => 0,
    width: 100,
  },
  {
    title: t('Comm. Type'),
    dataIndex: ['asset_data', 'communication_type'],
    key: 'communication_type',
    width: 150,
    sorter: () => 0,
  },
  {
    title: t('Tag'),
    dataIndex: ['asset_data', 'device_tag'],
    key: 'device_tag',
    width: 100,
    sorter: () => 0,
    render: (x: any, row: any) => (
      <span title={`fe_id: ${row.fe_id || ''}`}>{x}</span>
    ),
  },
  {
    title: t('Role'),
    dataIndex: ['role'],
    key: 'role',
    width: 100,
    sorter: () => 0,
  },
  {
    title: t('Custodian'),
    dataIndex: ['custodian', 'name'],
    key: 'custodian',
    width: 130,
    sorter: () => 0,
  },
  {
    title: t('Location'),
    dataIndex: ['location'],
    key: 'location',
    width: 100,
    sorter: () => 0,
  },
  {
    title: t('Wireless'),
    dataIndex: ['wireless'],
    key: 'wireless',
    width: 70,
    render: (x: any) => (x ? t('Yes') : t('No')),
  },
  {
    title: t('Source'),
    dataIndex: ['prm'],
    key: 'prm',
    ellipsis: true,
    width: 150,
    render: (x: any) => assetManagementApps[x]?.name,
  },
];

export default columns;
